import { DepositIcon } from '../Icons';
import { useTranslation } from 'react-i18next';
import { RemoteDepositCheckCapturePreviewProps } from '../../types/RemoteDepositCheck.types';

function ClaimRemoteDepositCheckCapturePreview({ altText, hasImage, imageSrc, labelId, labelText, onClick }: RemoteDepositCheckCapturePreviewProps) {
    const { t } = useTranslation('ClaimRemoteDepositCheck');

    return (
        <div>
            <label id={labelId} className="check-label">{labelText}</label>
            <div
                className="check-preview"
                aria-labelledby={labelId}
                onClick={onClick}
            >
                {!hasImage && (
                    <DepositIcon title={t('lblDepositIconTitle')} />
                )}
                {hasImage && (
                    <img
                        alt={altText}
                        src={imageSrc}
                        className="check-image"
                    />
                )}
            </div>
        </div>
    );
}

export default ClaimRemoteDepositCheckCapturePreview;
